import {
    POS_SALES_SUCCESS,
    POS_SALES_LOADING

} from '../actions/SalesAction';

const initialState = {
    salesData: [],
    isLoading: true
};

const SalesReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case POS_SALES_SUCCESS:
          return { ...state, salesData: action.data, isLoading: false };
        case POS_SALES_LOADING:
          return { ...state, isLoading: action.isLoading };
        default:
          return state;
      }
};

export default SalesReducer;
